<template>
	<div>
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<div style="margin-bottom: 20px;">
				<el-form ref="memberPageInfoReq" :model="memberPageInfoReq" label-width="70px" inline size="small">
					<el-form-item label="手机号:">
						<el-input :clearable = true v-model="memberPageInfoReq.mobile" placeholder="请输入手机号" style="width: 200px;" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="reGetmemberList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 会员列表区 -->
			<el-table :data="memberList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="用户编号" prop="memberNo"></el-table-column>
				<el-table-column label="运营商" prop="distributor"></el-table-column>
				<el-table-column label="手机号" prop="mobile"></el-table-column>
				<el-table-column label="骑乘次数" prop="tripCount"></el-table-column>
				<el-table-column label="总消费" prop="tripFee"></el-table-column>
				<el-table-column label="注册时间" prop="createTime" width="150" ></el-table-column>
				<el-table-column label="是否是运维人员" prop="isMaintain">
					<template slot-scope="scope">
						<el-switch active-color="#3CA757" v-model="scope.row.isMaintain"
							@change="switchIsMaintain(scope.row.isMaintain, scope.row.id,scope.row.memberNo)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="实名认证" prop="hasAuth">
					<template slot-scope="scope">
						{{ scope.row.hasAuth == 0 ? '否' : (scope.row.gender == 1 ? '是' : '未知') }}
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="status">
					<template slot-scope="scope">
						{{ scope.row.status == 1 ? '正常' : (scope.row.status == 2 ? '骑行中' : '未知') }}
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="memberPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="memberPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			memberPageInfoReq: {
				page: 1,
				limit: 8,
				mobile: '',
				queryDistributorId: ''
			},
			memberList: [],
			total: 0,
		}
	},
	created() {
		this.memberPageInfoReq.queryDistributorId = getCurrentDistributorId()
		this.getmemberList()
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.memberPageInfoReq.queryDistributorId = distributorId || ''
			this.memberPageInfoReq.page = 1
			this.getmemberList()
		},
		async getmemberList() {
			const {
				data: res
			} = await this.$http.post(
				'/member/manager/list', this.memberPageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.memberList = res.data.list || []
			this.total = res.data.total || 0
			this.memberList.map(function (val) {
				if (val.isMaintain == 1) {
					val.isMaintain = true;
				} else {
					val.isMaintain = false;
				}
			});
		},
		reGetmemberList() {
			if (this.memberPageInfoReq.startDate == null || this.memberPageInfoReq.endDate == null) {
				this.memberPageInfoReq.startDate = ''
				this.memberPageInfoReq.endDate = ''
			}
			this.memberPageInfoReq.page = 1;
			this.getmemberList();
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.memberPageInfoReq.limit = pageSize
			this.getmemberList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.memberPageInfoReq.page = pageNum
			this.getmemberList()
		},
		switchIsMaintain(isMaintain, id, memberNo) {
			this.$http.get('/member/manager/changeIsMaintain/' + isMaintain + "/" + id).then((res) => {
				console.log('res:'+ JSON.stringify(res));
				if (res.data.code == 200) {
					this.getmemberList();
					if(isMaintain){
						this.$message.success("编号为 " + memberNo + " 的用户已设为运维人员")
					}else {
						this.$message.success("编号为 " + memberNo + " 的用户已取消运维人员")
					}
					return;
				}
				this.$message.error(res.data.msg)
			})
		}
	},
}
</script>

<style>
</style>